export default __webpack_public_path__ + "static/media/sBASH.a011761c.png";